<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="order-main-sidebar" position="left" lockedOpen="gt-md">
        <order-main-sidebar></order-main-sidebar>
    </fuse-sidebar>

    <div class="center">
        <selling-navbar></selling-navbar>

        <div class="content-card" style="overflow-y: scroll;">
            <div class="mb-24" fxLayoutAlign="start" fxLayout.gt-md="row">
                <form class="mat-card mat-elevation-z4 p-24" fxLayout="column" fxLayoutAlign="start"
                      fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="!enabledVoucherSale">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button type="button" (click)="enableVoucherSale()" color="accent">
                                {{'Sale voucher'|translate}}
                            </button>
                        </div>
                    </div>
                    <h2 *ngIf="enabledVoucherSale">{{'Products sale'|translate}}</h2>
                    <table class="table">
                        <thead>
                        <tr>
                            <th style="width: 50%;">{{'Product'|translate}}</th>
                            <th style="width: 10%;">{{'Unit'|translate}}</th>
                            <th style="width: 10%;">{{'Quantity'|translate}}</th>
<!--                            <th style="width: 10%;">{{'Price net'|translate}}</th>-->
                            <th style="width: 10%;">{{'Vat rate'|translate}}</th>
                            <th style="width: 10%;">{{'Price gross'|translate}}</th>
                            <th style="font-weight: bold; text-align: center; vertical-align: center; width: 10%;">{{'Line value'|translate}}</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr formArrayName="items" *ngFor="let line of items().controls; index as i">
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="product" (selectionChange)="onProductSelect(i, $event)">
                                        <mat-option [value]="product.id" *ngFor="let product of products">
                                            {{product.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="unit">
                                        <mat-option [value]="unit.id" *ngFor="let unit of units">
                                            {{unit.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="quantity">
                                </mat-form-field>
                            </td>
<!--                            <td [formGroupName]="i">-->
<!--                                <mat-form-field appearance="outline"class="pr-4">-->
<!--                                    <input matInput formControlName="priceNet">-->
<!--                                </mat-form-field>-->
<!--                            </td>-->
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="vatRate">
                                        <mat-option [value]="vatRate.vatValue" *ngFor="let vatRate of vatRates">
                                            {{vatRate.vatName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline" class="pr-4">
                                    <input matInput formControlName="priceGross">
                                </mat-form-field>
                            </td>
                            <td style="font-weight: bold; text-align: center; vertical-align: center;">
                                {{calculateLineValue(i)}}
                            </td>
                            <td><button (click)="removeProductLine(i)" mat-raised-button color="warn">{{'Remove'|translate}}</button></td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td><button type="button" (click)="addProductLine()" mat-raised-button color="primary">{{'Add position'|translate}}</button></td>
                        </tr>
                        </tfoot>
                    </table>

                    <div *ngIf="enabledVoucherSale">
                        <h2>{{'Voucher sale'|translate}}</h2>
                        <table class="table" formArrayName="vouchers" *ngFor="let line of vouchers().controls; index as i">
                            <thead>
                            <tr>
                                <th style="width: 50%;">{{'Voucher'|translate}}</th>
                                <th style="width: 10%;">{{'Vat rate'|translate}}</th>
                                <th style="width: 10%;">{{'Price gross'|translate}}</th>
                                <th style="font-weight: bold; text-align: center; vertical-align: center; width: 10%;">{{'Line value'|translate}}</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td [formGroupName]="i">
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="voucherTemplate" (selectionChange)="onVoucherSelect(i, $event)">
                                            <mat-option [value]="voucherTemplate.id" *ngFor="let voucherTemplate of voucherTemplates">
                                                {{voucherTemplate.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                                <td [formGroupName]="i">
                                    <mat-form-field appearance="outline">
                                        <mat-select formControlName="vatRate">
                                            <mat-option [value]="vatRate.vatValue" *ngFor="let vatRate of vatRates">
                                                {{vatRate.vatName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                                <td [formGroupName]="i">
                                    <mat-form-field appearance="outline" class="pr-4">
                                        <input matInput formControlName="priceGross">
                                    </mat-form-field>
                                </td>
                                <td style="font-weight: bold; text-align: center; vertical-align: center;">
                                    {{calculateVoucherLineValue(i)}}
                                </td>
                                <td><button (click)="removeVoucherLine(i)" mat-raised-button color="warn">{{'Remove'|translate}}</button></td>
                            </tr>
                            <tr>
                                <td [formGroupName]="i">
                                    <mat-form-field appearance="outline" class="pr-4">
                                        <mat-label>{{'Owner'|translate}}</mat-label>
                                        <input matInput formControlName="owner">
                                    </mat-form-field>
                                </td>
                                <td [formGroupName]="i" colspan="2">
                                    <mat-form-field appearance="outline" class="pr-4">
                                        <mat-label>{{'Description'|translate}}</mat-label>
                                        <input matInput formControlName="description">
                                    </mat-form-field>
                                </td>
                                <td [formGroupName]="i" colspan="2">
                                    <mat-form-field appearance="outline" class="pr-4">
                                        <mat-label>{{'Dedication'|translate}}</mat-label>
                                        <input matInput formControlName="dedication">
                                    </mat-form-field>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <br/><button type="button" (click)="addVoucherLine()" mat-raised-button color="primary">{{'Add position'|translate}}</button>

                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="80">
                            <mat-label>{{'Customer'|translate}}</mat-label>
                            <input type="text"
                                   placeholder="{{ 'Customer'|translate }}"
                                   matInput
                                   formControlName="customer"
                                   [matAutocomplete]="auto">
                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                                <mat-option [value]="customer" *ngFor="let customer of filteredOptions|async">
                                    {{customer.firstName}} {{customer.lastName}}; {{customer.phone}}
                                </mat-option>
                            </mat-autocomplete>

<!--                            <mat-select formControlName="customer">-->
<!--                                <mat-option [value]="customer.id" *ngFor="let customer of customers">-->
<!--                                    {{customer.firstName}} {{customer.lastName}}; {{customer.phone}}-->
<!--                                </mat-option>-->
<!--                            </mat-select>-->
                        </mat-form-field>
                        <div fxFlex="20">
<!--                            <a mat-raised-button color="primary" (click)="addSupplier()">{{'Add supplier'|translate}}</a>-->
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100">
                            <mat-label>{{'Worker'|translate}}</mat-label>
                            <mat-select formControlName="worker">
                                <mat-option [value]="worker.id" *ngFor="let worker of workers">
                                    {{worker.firstName}} {{worker.lastName}}; {{worker.phone}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100">
                            <mat-label>{{'Payment method'|translate}}</mat-label>
                            <mat-select formControlName="paymentMethod">
                                <mat-option [value]="method" *ngFor="let method of paymentMethods">
                                    {{method}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100">
                            <mat-label>{{'Description'|translate}}</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="invoice" fxFlex="100" (change)="wantInvoice($event)">
                            <mat-label>{{'Create invoice'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>



                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="form.controls['invoice'].value">

                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                            <mat-label>{{'NIP'|translate}}</mat-label>
                            <input matInput formControlName="nip">
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="form.controls['invoice'].value">

                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                            <mat-label>{{'Name'|translate}}</mat-label>
                            <input matInput formControlName="companyName">
                            <mat-icon matSuffix class="secondary-text">home</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="form.controls['invoice'].value">

                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                            <mat-label>{{'Street'|translate}}</mat-label>
                            <input matInput formControlName="companyStreet">
                            <mat-icon matSuffix class="secondary-text">home</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" fxFlex="20" class="pr-4">
                            <mat-label>{{'Post code'|translate}}</mat-label>
                            <input matInput formControlName="companyPostCode">
                            <mat-icon matSuffix class="secondary-text">home</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" fxFlex="40" class="pl-4">
                            <mat-label>{{'City'|translate}}</mat-label>
                            <input matInput formControlName="companyCity">
                            <mat-icon matSuffix class="secondary-text">home</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="form.controls['invoice'].value">
                        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                            <mat-form-field appearance="outline" fxFlex="40">
                                <mat-label>{{'Country'|translate}}</mat-label>
                                <mat-select formControlName="companyCountry">
                                    <mat-option [value]="country.id" *ngFor="let country of countries">
                                        {{country.name}}
                                    </mat-option>
                                </mat-select>
                                <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                            </mat-form-field>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button type="submit" color="accent">
                                {{'Save'|translate}}
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</div>